module.exports = __webpack_public_path__ + "img/img-deco.2b4a2fb9.png";